import React from 'react';
import { Button } from '@chakra-ui/react';
import { Icon } from '@iconify/react';
import { ArrowForwardIcon } from '@chakra-ui/icons';
import image1 from '../assets/group-14.jpeg';
import image2 from '../assets/img.png';
import image3 from '../assets/img_1.png';
import image4 from '../assets/img_2.png';
import image5 from '../assets/img_3.png';
import image6 from '../assets/img_4.png';
import image7 from '../assets/img_5.png';
import image8 from '../assets/pic1.jpg';
import image9 from '../assets/img_6.png';
import riziki from '../assets/riziki.png';
import project1 from '../assets/project.png';

const PorfolioPCScreen = () => {
  return (
    <div className="porfolioPcScreen">
      <div className="header">
        <div className="ontalex">
          <span>{`</D`}</span>
          <span className="ntalex">evsKing</span>
          <span>{`>`}</span>
        </div>
        <div className="menu">
          <b
            className="aboutMe"
            onClick={() => window.location.replace('/#aboutMe1')}
          >
            about me
          </b>
          <b
            className="skills"
            onClick={() => window.location.replace('/#skills1')}
          >
            Skills
          </b>
          <b
            className="skills"
            onClick={() => window.location.replace('/#portfolio')}
          >
            Projects
          </b>
          <b
            className="skills"
            onClick={() => window.location.replace('/#footer')}
          >
            contacts
          </b>
        </div>
      </div>
      <div className="welcome" id="welcome">
        <div className="hiText">
          <div className="alexeyBorisov">Edwin Atieno</div>
          <b className="frontendDeveloper">Full-Stack</b>
          <div className="frontendDeveloperLooking">
            Full-stack developer looking for ideas and projects for himself and
            others
          </div>
        </div>
        <div className="illustrations">
          <div className="letButtonMenuContainer">
            <p className="letButtonMenu">
              let button_menu = document.querySelector(`header_button`);
            </p>
            <p className="letButtonMenu">
              let float_menu = document.querySelector(`.header_menu--float`);
            </p>
            <p className="letButtonMenu"></p>
            <p className="letButtonMenu">
              let line_top = document.querySelector(`.header_button_line--top`);
            </p>
            <p className="letButtonMenu">
              let line_under =
              document.querySelector(`.header_button_line--bottom`);
            </p>
            <p className="letButtonMenu"></p>
            <p className="letButtonMenu">button_menu.isSelected = false;</p>
            <p className="letButtonMenu"></p>
            <p className="letButtonMenu">{`function addEffectWriting(element, time) {
`}</p>
            <p className="letButtonMenu">
              {' '}
              let element_array = element.innerText.split(``);
            </p>
            <p className="letButtonMenu"></p>
            <p className="letButtonMenu"> element.count = 0;</p>
            <p className="letButtonMenu"> element.innerText = ``;</p>
            <p className="letButtonMenu"></p>
            <p className="letButtonMenu">{`  function writeSymbols() {
`}</p>
            <p className="letButtonMenu">
              {' '}
              element.innerText += element_array[element.count];
            </p>
            <p className="letButtonMenu"> element.count++;</p>
            <p className="letButtonMenu"></p>
            <p className="letButtonMenu">{`    if (element.count <= element_array.length) {
`}</p>
            <p className="letButtonMenu">{`      setTimeout(() => {
`}</p>
            <p className="letButtonMenu"> writeSymbols();</p>
            <p className="letButtonMenu">{`      }, time);
`}</p>
            <p className="letButtonMenu">{`    } else if (element.count >= element_array.length) {
`}</p>
            <p className="letButtonMenu"> element.count = 0;</p>
            <p className="letButtonMenu"> element.innerText = ``;</p>
            <p className="letButtonMenu"></p>
            <p className="letButtonMenu"> writeSymbols();</p>
            <p className="letButtonMenu">{`    }
`}</p>
            <p className="letButtonMenu">{`  }
`}</p>
            <p className="letButtonMenu"> writeSymbols();</p>
            <p className="letButtonMenu">{`}
`}</p>
          </div>
          <img className="illustrationsChild" alt="" src={image1} />
        </div>
      </div>
      <div className="aboutMe1" id="aboutMe1">
        <img className="logoIcon" alt="" src={image7} />
        <div className="aFewYears">
          A few years ago, I became interested in developing websites and
          interfaces. Since then, I have been steadily improving my skills. Now
          I am developing websites and web applications to order or for myself.
        </div>
      </div>
      <div className="skills1" id="skills1">
        <b className="mySkills">My Skills</b>
        <div className="lineSkills">
          <div className="cardSkillHtml">
            <div className="cardSkillHtmlChild" />
            <div className="iconHtmlParent">
              <img className="iconHtml" alt="" src={image6} />
              <div className="ontalex">Python</div>
            </div>
          </div>
          <div className="cardSkillHtml">
            <div className="cardSkillHtmlChild" />
            <div className="iconHtmlParent">
              <img className="iconCss" alt="" src={image3} />
              <div className="ontalex">Docker</div>
            </div>
          </div>
          <div className="cardSkillHtml">
            <div className="cardSkillHtmlChild" />
            <div className="iconJsParent">
              <img className="iconJs" alt="" src={image4} />
              <div className="ontalex">React</div>
            </div>
          </div>
          <div className="cardSkillHtml">
            <div className="cardSkillHtmlChild" />
            <div className="iconJsParent">
              <img className="iconJs" alt="" src={image5} />
              <div className="ontalex">DevOps</div>
            </div>
          </div>
          <div className="cardSkillHtml">
            <div className="cardSkillHtmlChild" />
            <div className="iconGitParent">
              <img className="iconGit" alt="" src={image2} />
              <div className="ontalex">Git</div>
            </div>
          </div>
        </div>
      </div>
      <div className="portfolio" id="portfolio">
        <b className="myWorks">My Works</b>
        <div className="gridPortfolio">
          <div className="cardPortfolio">
            <img
              className="cardPortfolioChild"
              alt="something wrong"
              src={image8}
            />
            <div className="discription">
              <b className="newsBlog">Data Science</b>
              <div className="htmlScssJs">Python</div>
              <div className="discriptionChild" />
              <div className="loremIpsumDolor">
                Project management is always a difficult and time consuming task
                which requires solid skills, long-term experience, and deep
                expertise in a certain domain.
              </div>
              <Button
                variant="solid"
                colorScheme="teal"
                rightIcon={<ArrowForwardIcon />}
                onClick={() =>
                  window.open(
                    'https://medium.com/@edwinatieno11/data-science-project-management-8a86f8bfd2a7',
                    '_blank'
                  )
                }
              >
                See more →
              </Button>
            </div>
          </div>
          <div className="cardPortfolio">
            <img className="cardPortfolioChild" alt="" src={project1} />
            <div className="discription">
              <b className="newsBlog">Sacco App</b>
              <div className="htmlScssJs">Group investment</div>
              <div className="discriptionChild" />
              <div className="loremIpsumDolor">
                Simple app to help investment groups to keep track of their
                money
              </div>
              <div className="rectangleParent">
                <div className="groupChild" />
                <Button
                  variant="solid"
                  colorScheme="teal"
                  rightIcon={<ArrowForwardIcon />}
                  onClick={() =>
                    window.open('https://github.com/EdwinAtieno/', '_blank')
                  }
                >
                  See more →
                </Button>
              </div>
            </div>
          </div>
          <div className="cardPortfolio">
            <img className="cardPortfolioChild" alt="" src={riziki} />
            <div className="discription">
              <b className="newsBlog">Riziki Apps</b>
              <div className="htmlScssJs">Riziki Grocery App</div>
              <div className="discriptionChild" />
              <div className="loremIpsumDolor">
                Creating everyday convenience and affordability, for the retail
                food ecosystem.
              </div>
              <Button
                variant="solid"
                colorScheme="teal"
                rightIcon={<ArrowForwardIcon />}
                onClick={() => window.open('https://riziki.co.ke/', '_blank')}
              >
                See more →
              </Button>
            </div>
          </div>
          <div className="cardPortfolio">
            <img className="cardPortfolioChild" alt="" src={image9} />
            <div className="discription">
              <b className="newsBlog">BootCamp</b>
              <div className="htmlScssJs">Python, Django, React</div>
              <div className="discriptionChild" />
              <div className="loremIpsumDolor">
                The most important task of Data Science management is to ensure
                the highest possible data quality.
              </div>
              <Button
                variant="solid"
                colorScheme="teal"
                rightIcon={<ArrowForwardIcon />}
                onClick={() =>
                  window.open(
                    'https://medium.com/@edwinatieno11/coding-experience-at-skaehub-company-5c6d4d3716c2',
                    '_blank'
                  )
                }
              >
                See more →
              </Button>
            </div>
          </div>
        </div>
      </div>
      <div className="footer" id="footer">
        <div className="ontalexParent">
          <div className="ontalex1">
            <span>{`</D`}</span>
            <span className="ntalex">evsKing</span>
            <span>{`>`}</span>
          </div>
          <div className="ifYouLiked">
            If you liked my work and you need me, Im ready to talk to you.
          </div>
        </div>
        <div className="ontactsParent">
          <b className="ontalex"> Сontacts</b>
          <div className="groupParent">
            <div className="mailParent">
              <div className="mail">
                <Icon icon="logos:google-gmail" />
                <div className="ontalex">edwinatieno11@gmail.com</div>
              </div>
              <div className="vk">
                <Icon icon="tabler:brand-vk" />
                <div className="ontalex">@edwinatieno</div>
              </div>
            </div>
            <div className="mailParent"></div>
            <div className="gitubParent">
              <div className="mail">
                <Icon icon="ri:github-fill" />
                <div className="ontalex">edwinatieno</div>
              </div>
              <div className="figma">
                <Icon icon="akar-icons:figma-fill" />
                <div className="ontalex">eddyatieno</div>
              </div>
            </div>
          </div>
        </div>
        <div></div>
        <div className="">
          <footer className="">
            Copyright &copy;{new Date().getFullYear()}
            <p style={{ color: 'white', fontSize: '17px' }}>
              DevsKing | All rights reserved
            </p>
          </footer>
        </div>
      </div>
    </div>
  );
};

export default PorfolioPCScreen;
